import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import {DEVICE_MANAGEMENT_ROUTES, TRAFFIC_LIGHT_ROUTES} from "../util/RouteConstants";
import SelectLayout, {NavigationRoutes} from "../util/SelectLayout";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS} from "../util/Constants";
import Alert from "@amzn/meridian/alert";
import Link from "@amzn/meridian/link";
import {FormattedMessage} from "react-intl";

const isPeakTime = false;

class DeviceManagementPage extends Component {
    render() {
        return (
            <Column spacingInset={"small large"} spacing={"medium"}>
                {isPeakTime && <Alert type={"warning"}>
                    <FormattedMessage id="banner.peakPermission"/>
                    <Link target={"_blank"} rel={"noopener noreferrer"}
                          href={"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/DeviceManagementSCC/#HWhyamInotabletoperformcertainfunctionsontheportalduringpeak3F"}>
                        <FormattedMessage id="banner.wiki"/>
                    </Link>
                </Alert>}
                <PageHeader {...PAGE_HEADERS.DEVICE_MANAGEMENT}> </PageHeader>
                <SelectLayout routes={DEVICE_MANAGEMENT_ROUTES.sort((a,b) => {
                    return a.name.localeCompare(b.name);
                })} location={this.props.location} history={this.props.history}/>
                <NavigationRoutes routes={DEVICE_MANAGEMENT_ROUTES}/>
                <NavigationRoutes routes={TRAFFIC_LIGHT_ROUTES}/>
            </Column>
        )
    }
}

export default DeviceManagementPage



// WEBPACK FOOTER //
// ./src/components/devicemanagement/DeviceManagementPage.js